/**
 * @file       Public maintenance page component
 * @version    1.0.0
 * @author     Boris Veits
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.
 *             All rights reserved. Property of
 *             MindShare HDV LLC. This file cannot be
 *             used or altered without expressed
 *             written permission from MindShare HDV LLC.
 */
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule }
    from '@angular/material/progress-spinner';
import { SettingService } from '@app/service/setting.service';

@Component
({
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports:
    [
        CommonModule,
        MatButtonModule,
        MatCardModule,
        MatProgressSpinnerModule
    ]
})
class MaintenanceComponent implements OnInit
{
    public loading: boolean;
    public message: string;

    /**
     * @desc   - component constructor
     * @access - public
     * @param  - router : Router
     * @param  - settingService : SettingService
     * @return -
     */
    constructor
    (
        private router: Router,
        private settingService: SettingService
    )
    {
    }

    /**
     * @desc   - angular initializer
     * @access - public
     * @param  -
     * @return -
     */
    ngOnInit()
    {
        this.loading = false;
        this.message =
            'SYSTEM IS IN MAINTENANCE, PLEASE CHECK ' +
            'BACK LATER.';
    }

    /**
     * @desc   - re-check maintenance; go to login if off
     * @access - public
     * @param  -
     * @return -
     */
    public onRefresh()
    {
        let isEnabledResult: boolean;

        this.loading = true;
        this.settingService
            .getPublicMaintenanceEnabled()
        .subscribe(
        {
            next: (isEnabled: boolean) =>
            {
                isEnabledResult = isEnabled === true;
                this.loading = false;

                if (isEnabledResult !== true)
                {
                    this.router.navigate(['/login']);
                }
            },
            error: () =>
            {
                this.loading = false;
                this.router.navigate(['/login']);
            }
        });
    }
}

export { MaintenanceComponent };
